module.exports = __webpack_public_path__ + "img/25.d8111f47.png";